// extracted by mini-css-extract-plugin
export default {"hero_container":"h-","hero_pic_container":"i-","hero_pic":"j-","hero_data_container":"k-","hero_data":"l-","hero_title":"m-","hero_text":"n-","hero_bottom_btn":"o-","hero_bottom_arrow":"p-"};
    if(module.hot) {
      // 1713969938165
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  